var _rect, _rect2, _text, _text2, _text3, _rect3, _path, _text4, _text5, _rect4, _path2, _text6, _text7, _rect5, _text8, _rect6, _text9, _rect7, _text0, _rect8, _text1, _rect9, _text10, _text11, _text12, _rect0, _path3, _text13, _text14, _rect1, _path4, _text15, _text16, _text17, _text18, _text19, _text20, _text21, _text22, _text23, _text24, _text25, _text26, _text27, _text28, _text29, _rect10, _text30, _rect11, _text31;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSettingsRu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1009 825",
    width: 1009,
    height: 825,
    fontFamily: "'Noto Sans','Segoe UI',Arial,sans-serif",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1009,
    height: 825,
    fill: "#232838"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 34,
    y: 25,
    width: 943,
    height: 775,
    rx: 8,
    fill: "#1f2231"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 71,
    y: 88,
    fill: "#ffffff",
    fontSize: 27,
    fontWeight: 400,
    textAnchor: "start"
  }, "\u041D\u0430\u0441\u0442\u0440\u043E\u0439\u043A\u0438 \u043A\u043E\u043F\u0438\u0440\u043E\u0432\u0430\u043D\u0438\u044F")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 71,
    y: 130,
    fill: "#3f7d3a",
    fontSize: 21,
    fontWeight: 400,
    textAnchor: "start"
  }, "\u041A\u043E\u043F\u0438\u0440\u043E\u0432\u0430\u0442\u044C \u043F\u0440\u043E\u043F\u043E\u0440\u0446\u0438\u043E\u043D\u0430\u043B\u044C\u043D\u043E:")), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 520,
    y: 130,
    fill: "#3f7d3a",
    fontSize: 21,
    fontWeight: 400,
    textAnchor: "start"
  }, "\u0421\u0442\u043E\u043F-\u0431\u0430\u043B\u0430\u043D\u0441:")), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 71,
    y: 148,
    width: 419,
    height: 53,
    rx: 6,
    fill: "#161e30",
    stroke: "#2f3b57"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M390 148.5H484a6 6 0 0 1 6 6V194.5a6 6 0 0 1 -6 6H390Z",
    fill: "#263149"
  })), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    x: 90,
    y: 182,
    fill: "#ffffff",
    fontSize: 22,
    fontWeight: 400,
    textAnchor: "start"
  }, "100")), _text5 || (_text5 = /*#__PURE__*/React.createElement("text", {
    x: 440,
    y: 182,
    fill: "#c9d3e6",
    fontSize: 20,
    fontWeight: 400,
    textAnchor: "middle"
  }, "%")), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 520,
    y: 148,
    width: 419,
    height: 53,
    rx: 6,
    fill: "#161e30",
    stroke: "#2f3b57"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M839 148.5H933a6 6 0 0 1 6 6V194.5a6 6 0 0 1 -6 6H839Z",
    fill: "#263149"
  })), _text6 || (_text6 = /*#__PURE__*/React.createElement("text", {
    x: 539,
    y: 182,
    fill: "#ffffff",
    fontSize: 22,
    fontWeight: 400,
    textAnchor: "start"
  }, "\u043D\u0430 \u0441\u0432\u043E\u0439 \u0432\u044B\u0431\u043E\u0440")), _text7 || (_text7 = /*#__PURE__*/React.createElement("text", {
    x: 889,
    y: 182,
    fill: "#c9d3e6",
    fontSize: 20,
    fontWeight: 400,
    textAnchor: "middle"
  }, "$")), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 71,
    y: 207,
    width: 80,
    height: 34,
    rx: 5,
    fill: "#272f44"
  })), _text8 || (_text8 = /*#__PURE__*/React.createElement("text", {
    x: 111,
    y: 231,
    fill: "#c9d3e6",
    fontSize: 18,
    fontWeight: 400,
    textAnchor: "middle"
  }, "x0.5")), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 156,
    y: 207,
    width: 80,
    height: 34,
    rx: 5,
    fill: "#343f58"
  })), _text9 || (_text9 = /*#__PURE__*/React.createElement("text", {
    x: 196,
    y: 231,
    fill: "#c9d3e6",
    fontSize: 18,
    fontWeight: 400,
    textAnchor: "middle"
  }, "x1")), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 241,
    y: 207,
    width: 80,
    height: 34,
    rx: 5,
    fill: "#272f44"
  })), _text0 || (_text0 = /*#__PURE__*/React.createElement("text", {
    x: 281,
    y: 231,
    fill: "#c9d3e6",
    fontSize: 18,
    fontWeight: 400,
    textAnchor: "middle"
  }, "x2")), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 326,
    y: 207,
    width: 80,
    height: 34,
    rx: 5,
    fill: "#272f44"
  })), _text1 || (_text1 = /*#__PURE__*/React.createElement("text", {
    x: 366,
    y: 231,
    fill: "#c9d3e6",
    fontSize: 18,
    fontWeight: 400,
    textAnchor: "middle"
  }, "x5")), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 411,
    y: 207,
    width: 80,
    height: 34,
    rx: 5,
    fill: "#272f44"
  })), _text10 || (_text10 = /*#__PURE__*/React.createElement("text", {
    x: 451,
    y: 231,
    fill: "#c9d3e6",
    fontSize: 18,
    fontWeight: 400,
    textAnchor: "middle"
  }, "x10")), _text11 || (_text11 = /*#__PURE__*/React.createElement("text", {
    x: 71,
    y: 301,
    fill: "#3f7d3a",
    fontSize: 21,
    fontWeight: 400,
    textAnchor: "start"
  }, "\u041C\u0438\u043D. \u0441\u0443\u043C\u043C\u0430 \u043A\u043E\u043F\u0438\u0440\u0443\u0435\u043C\u043E\u0439 \u0441\u0434\u0435\u043B\u043A\u0438:")), _text12 || (_text12 = /*#__PURE__*/React.createElement("text", {
    x: 520,
    y: 301,
    fill: "#3f7d3a",
    fontSize: 21,
    fontWeight: 400,
    textAnchor: "start"
  }, "\u041C\u0430\u043A\u0441. \u0441\u0443\u043C\u043C\u0430 \u043A\u043E\u043F\u0438\u0440\u0443\u0435\u043C\u043E\u0439 \u0441\u0434\u0435\u043B\u043A\u0438:")), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    x: 71,
    y: 318,
    width: 419,
    height: 53,
    rx: 6,
    fill: "#161e30",
    stroke: "#2f3b57"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M390 318.5H484a6 6 0 0 1 6 6V364.5a6 6 0 0 1 -6 6H390Z",
    fill: "#263149"
  })), _text13 || (_text13 = /*#__PURE__*/React.createElement("text", {
    x: 90,
    y: 352,
    fill: "#ffffff",
    fontSize: 22,
    fontWeight: 400,
    textAnchor: "start"
  }, "1")), _text14 || (_text14 = /*#__PURE__*/React.createElement("text", {
    x: 440,
    y: 352,
    fill: "#c9d3e6",
    fontSize: 20,
    fontWeight: 400,
    textAnchor: "middle"
  }, "$")), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
    x: 520,
    y: 318,
    width: 419,
    height: 53,
    rx: 6,
    fill: "#161e30",
    stroke: "#2f3b57"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M839 318.5H933a6 6 0 0 1 6 6V364.5a6 6 0 0 1 -6 6H839Z",
    fill: "#263149"
  })), _text15 || (_text15 = /*#__PURE__*/React.createElement("text", {
    x: 539,
    y: 352,
    fill: "#6f7b92",
    fontSize: 22,
    fontWeight: 400,
    textAnchor: "start"
  }, "\u041D\u0435\u043E\u0433\u0440\u0430\u043D\u0438\u0447\u0435\u043D\u043E")), _text16 || (_text16 = /*#__PURE__*/React.createElement("text", {
    x: 889,
    y: 352,
    fill: "#c9d3e6",
    fontSize: 20,
    fontWeight: 400,
    textAnchor: "middle"
  }, "$")), _text17 || (_text17 = /*#__PURE__*/React.createElement("text", {
    x: 71,
    y: 401,
    fill: "#8a9bb8",
    fontSize: 21,
    fontWeight: 400,
    textAnchor: "start"
  }, "\u0412\u044B \u043A\u043E\u043F\u0438\u0440\u0443\u0435\u0442\u0435")), _text18 || (_text18 = /*#__PURE__*/React.createElement("text", {
    x: 71,
    y: 431,
    fill: "#ffffff",
    fontSize: 21,
    fontWeight: 400,
    textAnchor: "start"
  }, "100% \u043E\u0442 \u0441\u0443\u043C\u043C\u044B \u0441\u0434\u0435\u043B\u043A\u0438 \u043F\u0440\u043E\u0432\u0430\u0439\u0434\u0435\u0440\u0430.")), _text19 || (_text19 = /*#__PURE__*/React.createElement("text", {
    x: 520,
    y: 401,
    fill: "#8a9bb8",
    fontSize: 21,
    fontWeight: 400,
    textAnchor: "start"
  }, "\u041A\u043E\u043F\u0438\u0440\u043E\u0432\u0430\u043D\u0438\u0435 \u043E\u0441\u0442\u0430\u043D\u043E\u0432\u0438\u0442\u0441\u044F \u043F\u0440\u0438 \u0431\u0430\u043B\u0430\u043D\u0441\u0435")), _text20 || (_text20 = /*#__PURE__*/React.createElement("text", {
    x: 520,
    y: 431,
    fill: "#8a9bb8",
    fontSize: 21,
    fontWeight: 400,
    textAnchor: "start"
  }, "\u043D\u0438\u0436\u0435")), _text21 || (_text21 = /*#__PURE__*/React.createElement("text", {
    x: 520,
    y: 461,
    fill: "#ffffff",
    fontSize: 21,
    fontWeight: 400,
    textAnchor: "start"
  }, "$10")), _text22 || (_text22 = /*#__PURE__*/React.createElement("text", {
    x: 71,
    y: 512,
    fill: "#8a9bb8",
    fontSize: 21,
    fontWeight: 400,
    textAnchor: "start"
  }, "\u041C\u0438\u043D. \u0441\u0443\u043C\u043C\u0430 \u0441\u043A\u043E\u043F\u0438\u0440\u043E\u0432\u0430\u043D\u043D\u043E\u0439 \u0441\u0434\u0435\u043B\u043A\u0438")), _text23 || (_text23 = /*#__PURE__*/React.createElement("text", {
    x: 71,
    y: 542,
    fill: "#ffffff",
    fontSize: 21,
    fontWeight: 400,
    textAnchor: "start"
  }, "$1")), _text24 || (_text24 = /*#__PURE__*/React.createElement("text", {
    x: 520,
    y: 512,
    fill: "#8a9bb8",
    fontSize: 21,
    fontWeight: 400,
    textAnchor: "start"
  }, "\u041C\u0430\u043A\u0441\u0438\u043C\u0430\u043B\u044C\u043D\u0430\u044F \u0441\u0443\u043C\u043C\u0430 \u0441\u043A\u043E\u043F\u0438\u0440\u043E\u0432\u0430\u043D\u043D\u043E\u0439")), _text25 || (_text25 = /*#__PURE__*/React.createElement("text", {
    x: 520,
    y: 542,
    fill: "#8a9bb8",
    fontSize: 21,
    fontWeight: 400,
    textAnchor: "start"
  }, "\u0441\u0434\u0435\u043B\u043A\u0438 \u0437\u0430\u0432\u0438\u0441\u0438\u0442 \u043E\u0442 \u0443\u0440\u043E\u0432\u043D\u044F \u043F\u0440\u043E\u0433\u0440\u0430\u043C\u043C\u044B")), _text26 || (_text26 = /*#__PURE__*/React.createElement("text", {
    x: 520,
    y: 572,
    fill: "#8a9bb8",
    fontSize: 21,
    fontWeight: 400,
    textAnchor: "start"
  }, "\u043B\u043E\u044F\u043B\u044C\u043D\u043E\u0441\u0442\u0438 \u0432\u0430\u0448\u0435\u0433\u043E \u0430\u043A\u043A\u0430\u0443\u043D\u0442\u0430.")), _text27 || (_text27 = /*#__PURE__*/React.createElement("text", {
    x: 71,
    y: 622,
    fill: "#ffffff",
    fontSize: 21,
    fontWeight: 400,
    textAnchor: "start"
  }, "\u0421\u0434\u0435\u043B\u043A\u0430 \u043F\u0440\u043E\u0432\u0430\u0439\u0434\u0435\u0440\u0430 \u043C\u0435\u043D\u0435\u0435 $1 \u043D\u0435 \u0431\u0443\u0434\u0435\u0442 \u0441\u043A\u043E\u043F\u0438\u0440\u043E\u0432\u0430\u043D\u0430.")), _text28 || (_text28 = /*#__PURE__*/React.createElement("text", {
    x: 71,
    y: 652,
    fill: "#ffffff",
    fontSize: 21,
    fontWeight: 400,
    textAnchor: "start"
  }, "\u041C\u0430\u043A\u0441\u0438\u043C\u0430\u043B\u044C\u043D\u0430\u044F \u0441\u0443\u043C\u043C\u0430 \u0441\u043A\u043E\u043F\u0438\u0440\u043E\u0432\u0430\u043D\u043D\u043E\u0439 \u0441\u0434\u0435\u043B\u043A\u0438 \u0437\u0430\u0432\u0438\u0441\u0438\u0442 \u043E\u0442 \u0443\u0440\u043E\u0432\u043D\u044F \u043F\u0440\u043E\u0433\u0440\u0430\u043C\u043C\u044B")), _text29 || (_text29 = /*#__PURE__*/React.createElement("text", {
    x: 71,
    y: 682,
    fill: "#ffffff",
    fontSize: 21,
    fontWeight: 400,
    textAnchor: "start"
  }, "\u043B\u043E\u044F\u043B\u044C\u043D\u043E\u0441\u0442\u0438 \u0432\u0430\u0448\u0435\u0433\u043E \u0430\u043A\u043A\u0430\u0443\u043D\u0442\u0430.")), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 527,
    y: 734,
    width: 195,
    height: 53,
    rx: 5,
    fill: "#283044"
  })), _text30 || (_text30 = /*#__PURE__*/React.createElement("text", {
    x: 624.5,
    y: 768,
    fill: "#ffffff",
    fontSize: 21,
    fontWeight: 500,
    textAnchor: "middle"
  }, "\u041D\u0430\u0437\u0430\u0434")), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 744.5,
    y: 734.5,
    width: 194,
    height: 52,
    rx: 5,
    fill: "#15262b",
    stroke: "#1d5a4a"
  })), _text31 || (_text31 = /*#__PURE__*/React.createElement("text", {
    x: 841.5,
    y: 768,
    fill: "#ffffff",
    fontSize: 21,
    fontWeight: 500,
    textAnchor: "middle"
  }, "\u041F\u043E\u0434\u0442\u0432\u0435\u0440\u0434\u0438\u0442\u044C")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettingsRu);
export default __webpack_public_path__ + "static/media/settings-ru.2e8e7bdfe3df149d94ef25697a85f684.svg";
export { ForwardRef as ReactComponent };